import { createNgReactBridgeDirective } from '../../react-bridge'
import { FailedScanRow } from '../../../components/notification-settings'

export const failedScanNotificationSettings = createNgReactBridgeDirective(
  'reactFailedScanNotificationSettings',
  [],
  FailedScanRow,
  [
    'entry',
    'i18nTitle',
    'i18nSubtitle',
    'fieldRequired',
    'i18nTooltipTitle',
    'i18nTooltipSubtitle',
    'onToggle'
  ]
)
